import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/sign-up")({
  beforeLoad: () => {
    // Temporarily closed: redirect anyone with the old sign-up URL back to login.
    return redirect({ to: "/auth/sign-in" });
  },
  component: SignUpPage,
});

function SignUpPage() {
  return null;
}
